module.exports = __webpack_public_path__ + "static/media/navidad6.5cb81838.jpg";